// Hebrew translations
const translations = {
  common: {
    smartCity: 'עיר חכמה',
    dashboard: 'לוח מחוונים',
    map: 'מפה',
    analytics: 'ניתוח נתונים',
    settings: 'הגדרות',
    profile: 'פרופיל',
    notifications: 'התראות',
    helpSupport: 'עזרה ותמיכה',
    systemStatus: 'סטטוס מערכת',
    search: 'חיפוש...',
    signOut: 'התנתק',
    systemRunningNormally: 'המערכת פועלת כרגיל',
    viewAllNotifications: 'צפה בכל ההתראות',
    toggleColorMode: 'החלף מצב צבע',
    administrator: 'מנהל מערכת',
    type: 'סוג',
    sensors: 'חיישנים',
    coordinates: 'קואורדינטות',
    view: 'צפה',
    details: 'פרטים',
    active: 'פעיל',
    inactive: 'לא פעיל',
    maintenance: 'תחזוקה',
    all: 'הכל',
    error: 'שגיאה',
    errorLoadingData: 'שגיאה בטעינת נתונים',
    refresh: 'רענן',
    success: 'הצלחה',
    required: 'שדה זה הוא חובה',
    invalidValue: 'ערך לא חוקי',
    invalidRange: 'הערך מחוץ לטווח תקין',
    operational: 'פעיל',
    notOperational: 'לא פעיל',
    timestamp: 'חותמת זמן',
    deviceId: 'מזהה מכשיר',
    lastUpdated: 'עדכון אחרון',
    exportData: 'ייצוא נתונים',
    saveChanges: 'שמור שינויים',
    updateFailed: 'העדכון נכשל',
    errorLoadingLocation: 'שגיאה בטעינת נתוני המיקום',
    backToLocations: 'חזרה למיקומים',
    description: 'תיאור',
    multiSelect: 'בחירה מרובה',
    clearSelection: 'נקה בחירה',
    delete: 'מחק',
  },

  dashboard: {
    trafficOverview: 'סקירת תנועה',
    recentEvents: 'אירועים אחרונים',
    sensorStatus: 'סטטוס חיישנים',
    systemHealth: 'בריאות המערכת',
    trafficVolume: 'נפח תנועה',
    incidents: 'תקריות',
    events: 'אירועים',
    sensors: 'חיישנים',
    reports: 'דוחות',
    calendar: 'לוח שנה',
    signalStatus: 'סטטוס אות',
    averageTravelTime: 'זמן נסיעה ממוצע',
    viewDetails: 'הצג פרטים',
    viewAll: 'הצג הכל',
    online: 'מחובר',
    offline: 'מנותק',
    uptime: 'זמן פעילות',
    responseTime: 'זמן תגובה',
    dataPoints: 'נקודות נתונים',
    lastUpdate: 'עדכון אחרון',

    // Added new location page translations
    addNew: 'הוסף חדש',
    searchLocations: 'חפש מיקומים...',
    filterByType: 'סנן לפי סוג',
    filterByStatus: 'סנן לפי סטטוס',
    grid: 'רשת',
    list: 'רשימה',
    noLocationsFound: 'לא נמצאו מיקומים',
    tryDifferentSearch: 'נסה חיפוש או סינון אחר',
    locationsDescription: 'ניהול וניטור נתוני מיקום',

    // Add location modal translations
    addNewLocation: 'הוסף מיקום חדש',
    locationNamePlaceholder: 'הכנס שם מיקום',
    locationAddressPlaceholder: 'הכנס כתובת',
    locationTypePlaceholder: 'לדוגמא: צומת, כביש מהיר וכו',
    locationAddedSuccess: 'המיקום נוסף בהצלחה',
    locationDeletedSuccess: 'המיקום נמחק בהצלחה',
    locationDeleteFailed: 'מחיקת המיקום נכשלה',
    deleteLocationsTitle: 'מחק מיקומים',
    deleteLocationsConfirm: 'האם אתה בטוח שברצונך למחוק {{count}} מיקומים?',
    deleteLocationsWarning: 'לא ניתן לבטל פעולה זו. כל החיישנים המחוברים למיקומים אלו ינותקו.',
    bulkDeleteSuccess: 'נמחקו בהצלחה {{count}} מיקומים',
    bulkDeletePartialSuccess: 'הצלחה חלקית: נמחקו {{success}} מיקומים, {{failed}} נכשלו',
    bulkDeleteFailed: 'מחיקת המיקומים נכשלה',
    locationUpdatedSuccess: 'המיקום עודכן בהצלחה',
    editLocationDesc: 'ערוך פרטים וקואורדינטות של המיקום',
    locationDescriptionPlaceholder: 'הזן תיאור מיקום (אופציונלי)',
    locationsMap: 'מפת מיקומים',
  },

  // הוספת הגדרות מערכת וקונפיגורציה
  settings: {
    dashboard: 'לוח הגדרות',
    system: 'הגדרות מערכת',
    user: 'הגדרות משתמש',
    organization: 'הגדרות ארגון',
    security: 'הגדרות אבטחה',
    notifications: 'הגדרות התראות',
    integrations: 'הגדרות אינטגרציה',
    maintenance: 'הגדרות תחזוקה',

    // ניהול משתמשים
    'User Management': 'ניהול משתמשים',
    'User Profiles': 'פרופילי משתמשים',
    'Role Management': 'ניהול תפקידים',
    'Permission Settings': 'הגדרות הרשאות',
    'Access Control': 'בקרת גישה',
    'User Groups': 'קבוצות משתמשים',
    Authentication: 'אימות',
    'Session Management': 'ניהול הפעלות',

    // קונפיגורציית מערכת
    'System Configuration': 'קונפיגורציית מערכת',
    'General Settings': 'הגדרות כלליות',
    'Performance Settings': 'הגדרות ביצועים',
    'Database Settings': 'הגדרות בסיס נתונים',
    'Cache Settings': 'הגדרות מטמון',
    'Logging Settings': 'הגדרות רישום',
    'Backup Settings': 'הגדרות גיבוי',
    'Import/Export': 'ייבוא/ייצוא',

    // הגדרות API ואינטגרציה
    'API Configuration': 'קונפיגורציית API',
    'Rate Limiting': 'הגבלת קצב',
    'Webhook Settings': 'הגדרות Webhook',
    'External APIs': 'API חיצוניים',
    'Data Sync': 'סנכרון נתונים',
    'Protocol Settings': 'הגדרות פרוטוקול',
    'Connection Testing': 'בדיקת חיבור',
    'Integration Status': 'סטטוס אינטגרציה',

    // ניהול התראות
    'Notification Types': 'סוגי התראות',
    'Email Settings': 'הגדרות דוא"ל',
    'SMS Settings': 'הגדרות SMS',
    'Push Notifications': 'התראות דחיפה',
    'Alert Preferences': 'העדפות התראה',
    'Delivery Methods': 'שיטות משלוח',
    'Escalation Rules': 'כללי הסלמה',
    'Notification Templates': 'תבניות התראה',

    // קונפיגורציית אבטחה
    'Password Policy': 'מדיניות סיסמאות',
    'Two-Factor Authentication': 'אימות דו-שלבי',
    'IP Restrictions': 'הגבלות IP',
    'SSL/TLS Settings': 'הגדרות SSL/TLS',
    'Encryption Settings': 'הגדרות הצפנה',
    'Audit Logging': 'רישום ביקורת',
    'Compliance Settings': 'הגדרות ציות',
    'Security Monitoring': 'מוניטורינג אבטחה',

    // ניהול נתונים
    'Data Retention': 'שמירת נתונים',
    'Data Archiving': 'ארכוב נתונים',
    'Data Purging': 'ניקוי נתונים',
    'Data Quality': 'איכות נתונים',
    'Data Sources': 'מקורות נתונים',
    'Data Validation': 'אימות נתונים',
    'Data Migration': 'העברת נתונים',
    'Data Backup': 'גיבוי נתונים',

    // הגדרות יישום
    'Theme Settings': 'הגדרות נושא',
    'Language Settings': 'הגדרות שפה',
    'Timezone Settings': 'הגדרות אזור זמן',
    'Display Settings': 'הגדרות תצוגה',
    'Layout Settings': 'הגדרות פריסה',
    'Dashboard Preferences': 'העדפות לוח מחוונים',
    'Widget Configuration': "קונפיגורציית ווידג'טים",
    'Chart Settings': 'הגדרות גרפים',

    // מוניטורינג מערכת
    'Health Monitoring': 'מוניטורינג בריאות',
    'Performance Monitoring': 'מוניטורינג ביצועים',
    'Resource Usage': 'שימוש במשאבים',
    'System Alerts': 'התראות מערכת',
    'Error Tracking': 'מעקב שגיאות',
    'Diagnostic Tools': 'כלי אבחון',
    'System Status': 'סטטוס מערכת',
    'Maintenance Windows': 'חלונות תחזוקה',

    // Dashboard settings UI
    configurePreferences: 'הגדר את העדפות לוח המחוונים שלך',
    generalSettings: 'הגדרות כלליות',
    displaySettings: 'הגדרות תצוגה',
    notificationSettings: 'הגדרות התראות',
    advancedSettings: 'הגדרות מתקדמות',
    language: 'שפה',
    languages: {
      english: 'אנגלית',
      russian: 'רוסית',
      kazakh: 'קזחית',
      arabic: 'ערבית',
      hebrew: 'עברית',
    },
    theme: 'ערכת נושא',
    light: 'בהיר',
    dark: 'כהה',
    systemDefault: 'ברירת מחדל של המערכת',
    enableNotifications: 'אפשר התראות',
    emailAlerts: 'התראות דוא"ל',
    dataRefreshInterval: 'מרווח רענון נתונים (דקות)',
    defaultMapView: 'תצוגת מפה ברירת מחדל',
    trafficView: 'תצוגת תנועה',
    satelliteView: 'תצוגת לוויין',
    streetsView: 'תצוגת רחובות',
    darkView: 'תצוגה כהה',
    dashboardLayout: 'פריסת לוח מחוונים',
    grid: 'רשת',
    list: 'רשימה',
    compact: 'קומפקטי',
    colorScheme: 'סכמת צבעים',
    blue: 'כחול',
    green: 'ירוק',
    purple: 'סגול',
    orange: 'כתום',
    red: 'אדום',
    dataCardSize: 'גודל כרטיס נתונים',
    small: 'קטן',
    medium: 'בינוני',
    large: 'גדול',
    showLegends: 'הצג מקרא בתרשימים',
    trafficIncidents: 'תקריות תנועה',
    sensorOfflineAlerts: 'התראות חיישן מנותק',
    congestionAlerts: 'התראות גודש',
    systemUpdates: 'עדכוני מערכת',
    dailyReports: 'דוחות יומיים',
    advancedUsersNote: 'הגדרות אלה מיועדות למשתמשים מתקדמות.',
    apiKey: 'מפתח API',
    apiKeyNote: 'מפתח זה משמש לאינטגרציות חיצוניות.',
    developerMode: 'מצב מפתח',
    debuggingTools: 'מאפשר כלי ניפוי באגים מתקדמים',
    dataRetention: 'שמירת נתונים (ימים)',
    logLevel: 'רמת רישום',
    warning: 'אזהרה',
    info: 'מידע',
    debug: 'ניפוי באגים',
    trace: 'מעקב',
    betaFeatures: 'הפעל תכונות בטא',
    resetDefaults: 'אפס לברירות מחדל',
    saveSettings: 'שמור הגדרות',
    saving: 'שומר',
    general: 'כללי',
    integrationsTab: 'אינטגרציות',
    integrationsDescription:
      'הגדר אינטגרציות צד שלישי, נקודות קצה API, ומיפויי שדות עבור לוח המחוונים של העיר החכמה שלך.',
  },

  // הוספת ממשק משתמש ורכיבים
  ui: {
    navigation: 'ניווט',
    menu: 'תפריט',
    toolbar: 'סרגל כלים',
    sidebar: 'סרגל צד',
    footer: 'כותרת תחתונה',
    header: 'כותרת עליונה',
    breadcrumb: 'נתיב דפדוף',
    pagination: 'עמידה',

    // אלמנטי טופס
    'Form Elements': 'אלמנטי טופס',
    'Input Fields': 'שדות קלט',
    'Select Boxes': 'תיבות בחירה',
    'Check Boxes': 'תיבות סימון',
    'Radio Buttons': 'כפתורי רדיו',
    'Text Areas': 'אזורי טקסט',
    'File Uploads': 'העלאת קבצים',
    'Date Pickers': 'בוחרי תאריך',
    'Time Pickers': 'בוחרי זמן',

    // כפתורים ופעולות
    'Primary Button': 'כפתור ראשי',
    'Secondary Button': 'כפתור משני',
    'Submit Button': 'כפתור שליחה',
    'Cancel Button': 'כפתור ביטול',
    'Reset Button': 'כפתור איפוס',
    'Edit Button': 'כפתור עריכה',
    'Delete Button': 'כפתור מחיקה',
    'Save Button': 'כפתור שמירה',
    'Apply Button': 'כפתור החלה',
    'Close Button': 'כפתור סגירה',
    'Back Button': 'כפתור חזרה',
    'Next Button': 'כפתור הבא',
    'Previous Button': 'כפתור קודם',
    'Refresh Button': 'כפתור רענון',
    'Search Button': 'כפתור חיפוש',
    'Clear Button': 'כפתור ניקוי',
    'Export Button': 'כפתור ייצוא',
    'Import Button': 'כפתור ייבוא',
    'Download Button': 'כפתור הורדה',
    'Upload Button': 'כפתור העלאה',

    // חלונות מודאליים ודיאלוגים
    'Modal Dialog': 'חלון מודאלי',
    'Confirmation Dialog': 'דיאלוג אישור',
    'Alert Dialog': 'דיאלוג התראה',
    'Info Dialog': 'דיאלוג מידע',
    'Warning Dialog': 'דיאלוג אזהרה',
    'Error Dialog': 'דיאלוג שגיאה',
    'Success Dialog': 'דיאלוג הצלחה',
    'Progress Dialog': 'דיאלוג התקדמות',

    // תצוגת נתונים
    'Data Table': 'טבלת נתונים',
    'Data Grid': 'רשת נתונים',
    'List View': 'תצוגת רשימה',
    'Card View': 'תצוגת כרטיסים',
    'Tree View': 'תצוגת עץ',
    'Chart View': 'תצוגת גרפים',
    'Map View': 'תצוגת מפה',
    'Detail View': 'תצוגת פרטים',

    // טעינה וסטטוס
    'Loading Spinner': 'מחוון טעינה',
    'Progress Bar': 'פס התקדמות',
    'Status Indicator': 'מחוון סטטוס',
    Badge: 'תג',
    Label: 'תווית',
    Tag: 'תגית',
    Chip: 'שבב',
    Tooltip: 'רמז כלי',

    // פריסה ומרווח
    'Grid Layout': 'פריסת רשת',
    'Flex Layout': 'פריסה גמישה',
    'Card Layout': 'פריסת כרטיסים',
    'Panel Layout': 'פריסת פאנלים',
    'Tab Layout': 'פריסת טאבים',
    'Accordion Layout': 'פריסת אקורדיון',
    'Sidebar Layout': 'פריסת סרגל צד',
    'Split Layout': 'פריסה מפוצלת',
  },

  map: {
    trafficSensors: 'חיישני תנועה',
    nearbyEvents: 'אירועים קרובים',
    fullScreen: 'מסך מלא',
    noEventsInArea: 'אין אירועים באזור זה',
    sensorDetails: 'פרטי חיישן',
    status: 'סטטוס',
    location: 'מיקום',
    lastReading: 'קריאה אחרונה',
    trafficFlow: 'זרימת תנועה',
    averageSpeed: 'מהירות ממוצעת',
  },

  analytics: {
    title: 'לוח ניתוח נתונים',
    timeRangeFilter: 'טווח זמן',
    sensorType: 'סוג חיישן',
    applyFilters: 'החל מסננים',
    trafficVolumeOverTime: 'נפח תנועה לאורך זמן',
    vehicleTypeDistribution: 'התפלגות סוגי רכב',
    congestionMetrics: 'מדדי גודש',
    averageDailyTraffic: 'תנועה יומית ממוצעת',
    peakHourVolume: 'נפח בשעת שיא',
    congestionIndex: 'מדד גודש',
    // Time range options
    timeRange: {
      day: '24 שעות אחרונות',
      week: '7 ימים אחרונים',
      month: '30 ימים אחרונים',
    },
    metricType: {
      traffic: 'נפח תנועה',
      speed: 'מהירות רכב',
      incidents: 'תקריות תנועה',
    },
    metrics: {
      totalTraffic: 'סך נפח תנועה',
      avgSpeed: 'מהירות ממוצעת',
      congestionLevel: 'רמת גודש',
      incidentCount: 'מספר תקריות',
    },
    trafficByLocation: 'תנועה לפי מיקום',
    trafficTrends: 'מגמות תנועה',
    trafficPatterns: 'דפוסי תנועה',
    speedByLocation: 'מהירות לפי מיקום',
    speedTrends: 'מגמות מהירות לאורך זמן',
    speedDistribution: 'התפלגות טווח מהירות',
    speedPatterns: 'דפוסי מהירות לפי זמן',
    incidentsByLocation: 'תקריות לפי מיקום',
    incidentTrends: 'מגמות תקריות',
    incidentTypes: 'התפלגות סוגי תקריות',
    incidentPatterns: 'דפוסי תקריות',
  },

  profile: {
    userProfile: 'פרופיל משתמש',
    editProfile: 'ערוך פרופיל',
    cancel: 'בטל',
    saveChanges: 'שמור שינויים',
    department: 'מחלקה',
    accessLevel: 'רמת גישה',
    memberSince: 'חבר מאז',
    lastLogin: 'התחברות אחרונה',
    personalInfo: 'מידע אישי',
    security: 'אבטחה',
    activeSessions: 'הפעלות פעילות',
    fullName: 'שם מלא',
    emailAddress: 'כתובת דוא"ל',
    phoneNumber: 'מספר טלפון',
    bio: 'ביוגרפיה',
    emailPrivacy: 'לעולם לא נשתף את הדוא"ל שלך.',
    password: 'סיסמה',
    lastPasswordChange: 'שונה לאחרונה לפני 30 ימים',
    changePassword: 'שנה סיסמה',
    twoFactorAuth: 'אימות דו-שלבי',
    enabled: 'מופעל',
    disabled: 'מושבת',
    enable: 'הפעל',
    disable: 'השבת',
    accountActivityNotifications: 'התראות פעילות חשבון',
    willReceiveNotifications: 'תקבל התראות לגבי פעילות בחשבון',
    wontReceiveNotifications: 'לא תקבל התראות לגבי פעילות בחשבון',
    currentSessions: 'הפעלות פעילות כעת',
    sessionsDescription: 'אלו הם מכשירים שהתחברו לחשבון שלך.',
    lastAccessed: 'גישה אחרונה',
    terminate: 'סיים',
    logoutAllDevices: 'התנתק מכל המכשירים',
  },

  notifications: {
    all: 'הכל',
    unread: 'לא נקרא',
    read: 'נקרא',
    archived: 'בארכיון',
    markAsRead: 'סמן כנקרא',
    actions: 'פעולות',
    markAsUnread: 'סמן כלא נקרא',
    archive: 'העבר לארכיון',
    delete: 'מחק',
    filterByType: 'סנן לפי סוג',
    allTypes: 'כל הסוגים',
    incident: 'תקרית',
    system: 'מערכת',
    maintenance: 'תחזוקה',
    alert: 'התראה',
    info: 'מידע',
    filterBySeverity: 'סנן לפי חומרה',
    allSeverities: 'כל רמות החומרה',
    low: 'נמוכה',
    medium: 'בינונית',
    high: 'גבוהה',
    critical: 'קריטית',
    filterByStatus: 'סנן לפי סטטוס',
    allStatuses: 'כל הסטטוסים',
    selectAll: 'בחר הכל',
    notificationsCount: 'התראות',
    noNotificationsFound: 'לא נמצאו התראות התואמות את המסננים שלך',
    actionRequired: 'נדרשת פעולה',
    source: 'מקור',
    relatedTo: 'קשור ל',
    noUnread: 'אין התראות שלא נקראו',
    noRead: 'אין התראות שנקראו',
    noArchived: 'אין התראות בארכיון',
    justNow: 'זה עתה',
    minutesAgo: 'לפני {{count}} דקות',
    hoursAgo: 'לפני {{count}} שעות',
    yesterday: 'אתמול',
    daysAgo: 'לפני {{count}} ימים',
  },

  // Search translations
  search: {
    advancedSearch: 'חיפוש מתקדם',
    searchPlaceholder: 'חפש אירועים, חיישנים, או מיקומים...',
    search: 'חיפוש',
    moreFilters: 'מסננים נוספים',
    lessFilters: 'פחות מסננים',
    activeFilters: 'מסננים פעילים',
    clearAll: 'נקה הכל',
    eventTypes: 'סוגי אירועים',
    locations: 'מיקומים',
    vehicleTypes: 'סוגי רכב',
    car: 'מכונית',
    bus: 'אוטובוס',
    truck: 'משאית',
    motorcycle: 'אופנוע',
    bicycle: 'אופניים',
    speedRange: 'טווח מהירות',
    customFilter: 'מסנן מותאם אישית',
    eventType: 'סוג אירוע',
    location: 'מיקום',
    timestamp: 'חותמת זמן',
    sensorType: 'סוג חיישן',
    speed: 'מהירות',
    status: 'סטטוס',
    equals: 'שווה',
    contains: 'מכיל',
    greaterThan: 'גדול מ',
    lessThan: 'קטן מ',
    range: 'טווח',
    addFilter: 'הוסף מסנן',
    results: 'תוצאות',
    selectEventType: 'בחר סוג אירוע',
    selectLocation: 'בחר מיקום',
    selectSensorType: 'בחר סוג חיישן',
    enterSpeed: 'הזן מהירות בקמ"ש',
    enterValue: 'הזן ערך',
  },

  integration: {
    apiKeys: 'מפתחות API',
    createApiKey: 'צור מפתח API',
    deleteApiKey: 'מחק מפתח API',
    regenerateApiKey: 'צור מחדש מפתח API',
    apiKeyName: 'שם מפתח API',
    apiKeyValue: 'ערך מפתח API',
    apiKeyCreated: 'מפתח API נוצר',
    apiKeyDeleted: 'מפתח API נמחק',
    apiKeyRegenerated: 'מפתח API נוצר מחדש',
    copyApiKey: 'העתק מפתח API',
    confirmDeleteApiKey: 'האם אתה בטוח שברצונך למחוק את מפתח ה-API הזה?',
    noApiKeys: 'לא נמצאו מפתחות API',

    endpoints: 'נקודות קצה',
    createEndpoint: 'צור נקודת קצה',
    deleteEndpoint: 'מחק נקודת קצה',
    endpointName: 'שם נקודת קצה',
    endpointUrl: 'כתובת URL של נקודת קצה',
    endpointMethod: 'שיטה',
    endpointCreated: 'נקודת קצה נוצרה',
    endpointDeleted: 'נקודת קצה נמחקה',
    noEndpoints: 'לא נמצאו נקודות קצה',

    fieldMappings: 'מיפויי שדות',
    createMapping: 'צור מיפוי',
    deleteMapping: 'מחק מיפוי',
    mappingName: 'שם מיפוי',
    sourceField: 'שדה מקור',
    targetField: 'שדה יעד',
    mappingCreated: 'מיפוי נוצר',
    mappingDeleted: 'מיפוי נמחק',
    noMappings: 'לא נמצאו מיפויי שדות',

    testIntegrations: 'בדוק אינטגרציות',
    savedTests: 'בדיקות שמורות',
    testConfiguration: 'תצורת בדיקה',
    testName: 'שם בדיקה',
    testDescription: 'תיאור בדיקה',
    method: 'שיטה',
    endpoint: 'נקודת קצה',
    headers: 'כותרות',
    headerKey: 'מפתח כותרת',
    headerValue: 'ערך כותרת',
    requestBody: 'גוף בקשה',
    jsonBody: 'גוף JSON',
    execute: 'בצע',
    response: 'תגובה',
    testSaved: 'הבדיקה נשמרה בהצלחה',
    testDeleted: 'הבדיקה נמחקה בהצלחה',
    noSavedTests: 'לא נמצאו בדיקות שמורות',
    requiredFields: 'שם ונקודת קצה נדרשים',
    endpointRequired: 'נקודת קצה נדרשת',
  },

  // Add header translations
  header: {
    expandSidebar: 'הרחב את סרגל הצד',
    collapseSidebar: 'כווץ את סרגל הצד',
    language: 'שנה שפה',
    selectLanguage: 'בחר שפה',
    recentNotifications: 'התראות אחרונות',
    notificationTitle: 'התראת מערכת',
    notificationDesc: 'התראת מערכת חדשה דורשת את תשומת לבך.',
    help: 'עזרה',
    toggleTheme: 'החלף ערכת נושא',
  },

  // Add sidebar translations
  sidebar: {
    app: {
      name: 'עיר חכמה',
    },
    main: 'ראשי',
    overview: 'סקירה',
    dashboard: 'לוח בקרה',
    map: 'מפה',
    calendar: 'לוח שנה',
    analytics: 'אנליטיקה',
    search: 'חיפוש',
    notifications: 'התראות',
    location: 'מיקום',
    incidents: 'אירועים',
    archive: 'ארכיון',
    monitoring: 'ניטור',
    sensorManagement: 'ניהול חיישנים',
    sensors: 'חיישנים',
    sensorHealth: 'תקינות חיישנים',
    events: 'אירועים',
    trafficManagement: 'ניהול תנועה',
    trafficLogs: 'יומני תנועה',
    trafficEvents: 'אירועי תנועה',
    trafficViolations: 'עבירות תנועה',
    trafficAnalytics: 'ניתוח תנועה',
    reports: 'דוחות',
    administration: 'ניהול',
    users: 'משתמשים',
    userRoles: 'תפקידי משתמשים',
    account: 'חשבון',
    profile: 'פרופיל',
    profileSettings: 'הגדרות פרופיל',
    system: 'מערכת',
    systemHealth: 'תקינות מערכת',
    integrations: 'אינטגרציות',
    translations: 'תרגומים',
    storage: 'אחסון',
    backups: 'גיבויים',
    license: 'רישיון',
    help: 'עזרה',
    queueManager: 'מנהל תורים',
    workers: 'עובדים',
  },

  calendar: {
    month: 'חודש',
    week: 'שבוע',
    day: 'יום',
    list: 'רשימה',
    addEvent: 'הוסף אירוע',
    eventDetails: 'פרטי אירוע',
    title: 'כותרת',
    description: 'תיאור',
    location: 'מיקום',
    startDate: 'תאריך ושעת התחלה',
    endDate: 'תאריך ושעת סיום',
    allDay: 'כל היום',
    eventType: 'סוג אירוע',
    priority: 'עדיפות',
    status: 'סטטוס',
    trafficEvent: 'אירוע תנועה',
    maintenance: 'תחזוקה',
    meeting: 'פגישה',
    alert: 'התראה',
    other: 'אחר',
    low: 'נמוכה',
    medium: 'בינונית',
    high: 'גבוהה',
    pending: 'ממתין',
    inProgress: 'בתהליך',
    completed: 'הושלם',
    cancelled: 'בוטל',
    save: 'שמור',
    delete: 'מחק',
    cancel: 'בטל',
    loading: 'טוען לוח שנה...',
    eventCreated: 'האירוע נוצר',
    eventUpdated: 'האירוע עודכן',
    eventDeleted: 'האירוע נמחק',
    assignees: 'אחראים',
    yes: 'כן',
    no: 'לא',
    // FullCalendar specific translations
    currentDay: 'היום',
    dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
    dayNamesShort: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ש'"],
    monthNames: [
      'ינואר',
      'פברואר',
      'מרץ',
      'אפריל',
      'מאי',
      'יוני',
      'יולי',
      'אוגוסט',
      'ספטמבר',
      'אוקטובר',
      'נובמבר',
      'דצמבר',
    ],
    monthNamesShort: [
      'ינו',
      'פבר',
      'מרץ',
      'אפר',
      'מאי',
      'יונ',
      'יול',
      'אוג',
      'ספט',
      'אוק',
      'נוב',
      'דצמ',
    ],
    buttonText: {
      today: 'היום',
      month: 'חודש',
      week: 'שבוע',
      day: 'יום',
      list: 'רשימה',
    },
    allDayText: 'כל היום',
    moreLinkText: 'עוד',
    noEventsText: 'אין אירועים להצגה',
    // Add locale property for FullCalendar
    locale: 'he',
  },

  // Add new sensor health translations
  sensorHealth: {
    dashboard: 'לוח בקרת בריאות חיישנים',
    overview: 'סקירת בריאות חיישנים',
    details: 'פרטי חיישן',
    loading: 'טוען חיישן...',
    error: 'שגיאה בטעינת חיישן',
    notFound: 'חיישן לא נמצא',
    sensorNotFound: 'חיישן עם מזהה {{id}} לא נמצא',
    editSensor: 'ערוך חיישן',
    exportData: 'ייצוא נתונים',
    metrics: {
      uptime: 'זמן פעילות',
      signalStrength: 'עוצמת אות',
      batteryLevel: 'רמת סוללה',
      responseTime: 'זמן תגובה',
      dataRate: 'קצב נתונים',
      temperature: 'טמפרטורה',
      humidity: 'לחות',
      errorRate: 'שיעור שגיאות',
      packetLoss: 'איבוד חבילות',
      connectionStatus: 'מצב חיבור',
      operationalStatus: 'מצב תפעולי',
      firmwareVersion: 'גרסת קושחה',
      hardwareVersion: 'גרסת חומרה',
      lastCalibration: 'כיול אחרון',
      selfTestStatus: 'מצב בדיקה עצמית',
      lastUpdated: 'עדכון אחרון',
    },
    alerts: 'התראות',
    status: {
      online: 'מחובר',
      offline: 'מנותק',
      warning: 'אזהרה',
      error: 'שגיאה',
      maintenance: 'תחזוקה',
      all: 'כל החיישנים',
      connected: 'מחובר',
      disconnected: 'מנותק',
      intermittent: 'לסירוגין',
      active: 'פעיל',
      idle: 'לא פעיל',
    },
    metricsData: {
      batteryLevel: 'רמת סוללה',
      signalStrength: 'עוצמת אות',
      uptime: 'זמן פעילות',
      responseTime: 'זמן תגובה',
      dataRate: 'קצב נתונים',
      temperature: 'טמפרטורה',
      humidity: 'לחות',
      lastUpdated: 'עדכון אחרון',
    },
    alertsData: {
      title: 'התראות',
      noAlerts: 'אין התראות',
      lowBattery: 'סוללה חלשה',
      signalLoss: 'אובדן אות',
      highTemperature: 'טמפרטורה גבוהה',
      maintenance: 'נדרשת תחזוקה',
      severity: {
        low: 'נמוכה',
        medium: 'בינונית',
        high: 'גבוהה',
        critical: 'קריטית',
      },
      status: {
        active: 'פעילה',
        resolved: 'נפתרה',
        acknowledged: 'אושרה',
        ignored: 'התעלמות',
      },
    },
    diagnostics: {
      title: 'אבחון',
      selfTest: 'בדיקה עצמית',
      passed: 'עבר',
      failed: 'נכשל',
      voltage: 'מתח',
      memory: 'שימוש בזיכרון',
      cpu: 'שימוש במעבד',
      errorCodes: 'קודי שגיאה',
    },
    performance: {
      title: 'ביצועים',
      excellent: 'מצוין',
      good: 'טוב',
      fair: 'סביר',
      poor: 'חלש',
      packetLoss: 'אובדן חבילות',
      latency: 'שיהוי',
      jitter: 'ריצוד',
      throughput: 'תפוקה',
    },
    filter: {
      searchPlaceholder: 'חיפוש חיישנים...',
      filterByStatus: 'סינון לפי סטטוס',
      applyFilters: 'החל מסננים',
      resetFilters: 'אפס מסננים',
      sortBy: 'מיון לפי',
    },
    actions: {
      viewDetails: 'הצג פרטים',
      refreshData: 'רענן נתונים',
      exportData: 'ייצוא נתונים',
      createAlert: 'צור התראה',
      scheduleMaintenence: 'תזמן תחזוקה',
      resetSensor: 'אפס חיישן',
    },
    healthLog: {
      title: 'יומן בריאות',
      noData: 'אין נתוני יומן בריאות זמינים',
      noLogsReceived: 'לא התקבלו רשומות יומן בריאות מחיישן זה',
      deviceStatus: 'סטטוס מכשיר',
      radarStatus: 'סטטוס רדאר',
      cameraStatus: 'סטטוס מצלמה',
      gpsStatus: 'סטטוס GPS',
      ledStatus: 'סטטוס LED',
      latestStatus: 'סיכום סטטוס אחרון',
      systemHealth: 'בריאות מערכת',
      allSystemsOperational: 'כל המערכות פעילות',
      systemIssuesDetected: 'זוהו בעיות במערכת',
      lastStatusUpdate: 'עדכון סטטוס אחרון',
    },
  },

  // מצבים ריקים - הודעות אינפורמטיביות עם איורים
  emptyStates: {
    // חיישנים
    noSensors: {
      title: 'לא נמצאו חיישנים',
      description: 'התחל בהוספת החיישן הראשון שלך לניטור תעבורה ואיסוף נתונים.',
      primaryAction: 'הוסף חיישן',
      secondaryAction: 'למד עוד',
    },
    noSensorsFiltered: {
      title: 'אין חיישנים תואמים',
      description:
        'אין חיישנים התואמים לקריטריוני הסינון הנוכחיים. נסה לשנות את המסננים או תנאי החיפוש.',
      primaryAction: 'נקה מסננים',
    },

    // מיקומים
    noLocations: {
      title: 'לא נמצאו מיקומים',
      description: 'הוסף מיקומים לארגון החיישנים ולניטור תעבורה באזורים ספציפיים.',
      primaryAction: 'הוסף מיקום',
      secondaryAction: 'ייבא מיקומים',
    },
    noLocationsFiltered: {
      title: 'אין מיקומים תואמים',
      description: 'אין מיקומים התואמים לחיפוש שלך. נסה מונח חיפוש אחר או עיין בכל המיקומים.',
      primaryAction: 'נקה חיפוש',
    },

    // אירועים
    noEvents: {
      title: 'לא נמצאו אירועים',
      description:
        'אירועי תעבורה יופיעו כאן כאשר החיישנים יתחילו לזהות פעילות. ודא שהחיישנים שלך מקוונים ומוגדרים כראוי.',
      primaryAction: 'בדוק חיישנים',
      secondaryAction: 'רענן',
    },
    noEventsFiltered: {
      title: 'אין אירועים תואמים',
      description:
        'אין אירועים התואמים למסננים הנוכחיים. נסה לשנות את טווח התאריכים, קריטריוני הסינון או לוודא קישוריות החיישנים.',
      descriptionWithQuery:
        'אין אירועים התואמים ל-"{{query}}". נסה מונחי חיפוש שונים, שנה את טווח התאריכים או בדוק את קריטריוני הסינון.',
      descriptionWithEventId: 'לא נמצא אירוע עם מזהה "{{query}}". ודא שמזהה האירוע נכון.',
      primaryAction: 'נקה מסננים',
      secondaryAction: 'רענן',
    },

    // הפרות
    noViolations: {
      title: 'לא נמצאו הפרות',
      description: 'אין הפרות התואמות למסננים הנוכחיים. נסה לשנות את טווח התאריכים או סוג ההפרה.',
      primaryAction: 'התאם מסננים',
      secondaryAction: 'רענן',
    },

    // הפרות חגורת בטיחות
    noSeatbeltViolations: {
      title: 'אין הפרות חגורת בטיחות',
      description:
        'הפרות חגורת בטיחות יופיעו כאן כאשר החיישנים יתחילו לזהות אותן. ודא שהחיישנים שלך מקוונים ומוגדרים לזיהוי הפרות חגורת בטיחות.',
      primaryAction: 'בדוק חיישנים',
      secondaryAction: 'רענן',
    },
    noSeatbeltViolationsFiltered: {
      title: 'אין הפרות תואמות',
      description:
        'אין הפרות חגורת בטיחות התואמות למסננים הנוכחיים. נסה לשנות את טווח התאריכים, קריטריוני הסינון או להרחיב את פרמטרי החיפוש.',
      descriptionWithQuery:
        'אין הפרות חגורת בטיחות התואמות ל-"{{query}}". נסה מונחי חיפוש שונים, שנה את טווח התאריכים או בדוק את קריטריוני הסינון.',
      descriptionWithEventId:
        'לא נמצאה הפרת חגורת בטיחות עם מזהה "{{query}}". ודא שמזהה האירוע נכון.',
      primaryAction: 'נקה מסננים',
      secondaryAction: 'רענן',
    },

    // דוחות
    noReports: {
      title: 'אין דוחות עדיין',
      description: 'צור דוחות מותאמים אישית לניתוח דפוסי תעבורה, נתוני חיישנים והפרות לאורך זמן.',
      primaryAction: 'צור דוח',
      secondaryAction: 'צפה בתבניות',
    },

    // התראות
    noNotifications: {
      title: 'אין התראות',
      description: 'אתה מעודכן! התראות חדשות יופיעו כאן כשתהיה פעילות.',
      primaryAction: 'הגדרות התראות',
    },
    allNotificationsRead: {
      title: 'הכל נקרא!',
      description: 'אין לך התראות שלא נקראו.',
      primaryAction: 'הצג הכל',
    },

    // תוצאות חיפוש
    noSearchResults: {
      title: 'לא נמצאו תוצאות',
      description: 'לא נמצאו תוצאות. נסה מילות מפתח שונות או הרחב את החיפוש.',
      descriptionWithQuery:
        'לא נמצאו תוצאות עבור "{{query}}". נסה מילות מפתח שונות או בדוק את האיות.',
      primaryAction: 'נקה חיפוש',
      secondaryAction: 'התאם מסננים',
      tipsTitle: 'טיפים לחיפוש',
      tips: {
        checkSpelling: 'בדוק את האיות ונסה שוב',
        useKeywords: 'השתמש במילות מפתח כלליות יותר',
        removeFilters: 'הסר כמה מסננים כדי להרחיב את החיפוש',
        tryDifferentTerms: 'נסה מונחי חיפוש שונים',
      },
    },

    // ארכיון
    noArchive: {
      title: 'אין אירועים בארכיון',
      description:
        'אירועים נשמרים בארכיון באופן אוטומטי בהתאם למדיניות השמירה. אירועים בארכיון נשמרים לצרכי ציות וניתוח היסטורי תוך אופטימיזציה של בסיס הנתונים הפעיל.',
      primaryAction: 'הגדר מדיניות שמירה',
      secondaryAction: 'למד עוד',
    },
    noArchiveFiltered: {
      title: 'אין אירועי ארכיון תואמים',
      description:
        'אין אירועי ארכיון התואמים למסננים הנוכחיים. נסה לשנות את טווח התאריכים, סוג האירוע או רמת החומרה.',
      descriptionWithQuery:
        'אין אירועי ארכיון התואמים ל-"{{query}}". נסה מונחי חיפוש שונים או התאם את קריטריוני הסינון.',
      primaryAction: 'נקה מסננים',
      secondaryAction: 'רענן',
    },

    // אין נתונים כללי
    noData: {
      title: 'אין נתונים זמינים',
      description: 'אין נתונים להצגה כרגע. בדוק מאוחר יותר או נסה לרענן.',
      primaryAction: 'רענן',
    },
  },
};

export default translations;
